import RaixerConfig from '../Config/RaixerConfig'

export const retryIfNetworkError = (fn, route, params, headers, retry) => {
  retry = retry || 0
  return fn(route, params, { headers })
    .then((response) => {
      const { ok, problem } = response
      if (!ok) {
        if (problem === 'NETWORK_ERROR') {
          if (retry < RaixerConfig.api.retries) {
            return retryIfNetworkError(fn, route, params, headers, retry + 1)
          }
        }
      }
      return response
    })
}